<template>
  <div style="height: 100%; width: 100%;">
    <el-menu
      :default-active="this.$router.currentRoute.path == '/admin/disputes' ? '/admin/disputes/submitted' : this.$router.currentRoute.path"
      :router="true"
      mode="horizontal"
    >
      <el-menu-item
        v-if="$store.getters.hasPermission(['All', 'Dispute-Finalize', 'Disputes'])"
        index="/admin/disputes/submitted"
      >Submitted</el-menu-item>
      <el-menu-item
        v-if="$store.getters.hasPermission(['All', 'Dispute-Approve', 'Disputes'])"
        index="/admin/disputes/finalized"
      >Finalized</el-menu-item>
      <el-menu-item
        v-if="$store.getters.hasPermission(['All', 'Dispute-Approve', 'Disputes'])"
        index="/admin/disputes/resolved"
      >Resolved</el-menu-item>
    </el-menu>
    <div style="margin: 16px;">
        <router-view></router-view>
    </div>
  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    created() {
        if (
            !this.$store.getters.hasPermission([
                "All",
                "Disputes",
                "Dispute-Finalize",
                "Dispute-Approve"
            ])
        )
            this.$router.push("/admin");
        if(this.$router.currentRoute.path == '/admin/disputes'){
            this.$router.push('/admin/disputes/submitted');
        }
    },
    computed: {...mapFields(["user", "users", "permissions"])},
    mounted() {
        if (this.dispute_types == null) this.$store.dispatch("pullDisputeTypes");
        if (this.levels == null) this.$store.dispatch("pullLevels");
    },
    methods: {
        exportDisputes() {
            this.axios({
                url: "/api/v1/attendance/disputes/export",
                method: "GET",
                responseType: "blob" // Important
            }).then((response) => {
                if (navigator.msSaveBlob) {
                    var blob = new Blob([response.data], {type: "application/zip;charset=utf-8;"});
                    navigator.msSaveBlob(blob, "disputes.zip");
                } else {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "disputes.zip");
                    document.body.appendChild(link);
                    link.click();
                }
            });
        }
    }
};
</script>
